import React, { useState, useContext, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import cover from 'src/assets/cover/login_cover.webp';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


import { useNavigate } from 'react-router-dom';

import UserContext from '../../context/UserContext';
import axios from 'axios';
import { url } from 'src/api/environment';

import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDireciton: 'column'
  },
  container: {
    height: 'calc(100vh - 4rem)',
    backgroundImage: `url(${cover})`,
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 4rem)',
    },
  },
  login: {
    backgroundColor: 'white',
    padding: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 4rem)',
      borderRadius: 0
    },
  }
}));

const RegisterView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const {setUserData} = useContext(UserContext);

  const navigate = useNavigate();
  
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [passwordCheck, setPasswordCheck] = useState();
  const [displayName, setDisplayName] = useState();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [loading, setLoading] = useState(false);

  const [isRegisteredToNewsletter, setIsRegisteredToNewsletter] = useState(false);

  const handleChange = (event) => {
    setIsRegisteredToNewsletter(event.target.checked);
  };

  useEffect(() => {
    if(error !== '') {
      enqueueSnackbar(error, { variant: 'error' });
    }
  }, [error]);

  useEffect(() => {
    if(error !== '') {
      enqueueSnackbar(error, { variant: 'error' });
    }
  }, [error]);

  useEffect(() => {
    if(success !== '') {
      enqueueSnackbar(success, { variant: 'success' });
    }
  }, [success])
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const newUser = { email, password, passwordCheck, displayName, isRegisteredToNewsletter };
      await axios.post(
        `${url}/users/register`, newUser
      );
      const loginRes = await axios.post(
        `${url}/users/login`, {email, password}
      );
      setUserData({
        token: loginRes.data.token,
        user: loginRes.data.user
      });
  
      localStorage.setItem('auth-token', loginRes.data.token);
      setSuccess('Création du compte réussi ! Bonjour ' + loginRes.data.user.displayName);
      setLoading(false);
      navigate('/my-account');
    }
    catch(error) {
      error.response.data.message && setError(error.response.data.message);
      setLoading(false);
    }
  }

  return (
    <>
      <Container
        className={classes.container}
        disableGutters
        elevation={0}
        maxWidth="xl"
      >
        <Paper
          className={classes.login}
          elevation={1}
        >
          <Typography
            align="center"
            component="h2"
            variant="h1"
          >
            Creer un compte
          </Typography>
          <form
            autoComplete="off"
            className={classes.form}
            noValidate
            onSubmit={handleSubmit}
          >
            <FormGroup style={{width: '100%'}}>
              <TextField
                // autoComplete="current-password"
                id="email"
                label="Adresse Email"
                onChange={(e) => setEmail(e.target.value)}
                style={{marginBottom: '1rem', width: '100%'}}
                type="email"
                variant="outlined"
              />
              <TextField
                // autoComplete="current-password"
                id="displayName"
                label="Votre Pseudo"
                onChange={(e) => setDisplayName(e.target.value)}
                style={{marginBottom: '1rem'}}
                type="text"
                variant="outlined"
              />
              <TextField
                autoComplete="current-password-1"
                id="password"
                label="Mot de passe"
                onChange={(e) => setPassword(e.target.value)}
                style={{marginBottom: '1rem'}}
                type="password"
                variant="outlined"
              />
              <TextField
                autoComplete="current-password-2"
                id="passwordCheck"
                label="Confirmer Mot de passe"
                onChange={(e) => setPasswordCheck(e.target.value)}
                style={{marginBottom: '1rem'}}
                type="password"
                variant="outlined"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isRegisteredToNewsletter}
                    name="gilad"
                    onChange={handleChange}
                  />}
                label="Inscription à la Newsletter"
              />
              <Button
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
              >
                {!loading ? 
                  'Valider' :
                  <CircularProgress
                    size={30}
                    style={{color: 'white'}}
                  />
                }
              </Button>
            </FormGroup>
          </form>
          <Typography
            style={{marginTop: '1rem'}}
            variant="body1"
          >
            Vous avez déja un compte ? <br />
            <Link to="/login">
              <span style={{color: 'rgb(112, 195, 89)' }}>Connectez-vous</span>
            </Link>
          </Typography>
          <Typography
            style={{marginTop: '2rem', fontSize: '0.9rem'}}
            variant="subtitle1"
          >
            {error}
          </Typography>
        </Paper>
      </Container>
    </>
  );
}

export default RegisterView;
